import { render, staticRenderFns } from "./VatBreakdownReport.vue?vue&type=template&id=638d2bea&"
import script from "./VatBreakdownReport.vue?vue&type=script&lang=js&"
export * from "./VatBreakdownReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports